import { Form, Input, Select } from 'antd'
import React,{useState,useEffect} from 'react'
import { css } from '@emotion/react'
 /** @jsxImportSource @emotion/react */
 import { ButtonBase } from '@mui/material';
 import config from '../../config';
 import axios from '../apiClient';
 import Loader from '../loader';
 import Alert from '../alert';
import jwtDecode from 'jwt-decode';
 
 export default function CreateSubAccount() {
   
   const [loading,setLoading] = useState(false)
   const [errorMsg, setErrorMsg] = useState({});
   const [openAlert, setOpenAlert] = useState(false);
   const [agentName,setAgentName] = useState();
   const [accessTypes,setAccessTypes] = useState([]);
   const [form] = Form.useForm();

   useEffect(()=>{
    const token = localStorage.getItem("token");
    const {name} = jwtDecode(token)
    setAgentName(name);
    getAccessTypes();
  },[])

  
  const getAccessTypes = async() => {
    const res = await axios.get(`/owner/getAccessTypesList`);
    if(res.code == 200) {
      let arr = [...res.data,{access_types: '*',display_name: 'All'}]
      setAccessTypes(arr)
    }
  }

  const handleUsernameChange = (e) =>{
    form.setFieldsValue({
      username: e.currentTarget.value.toUpperCase().replace(/ /g, '')
    });
  }

  const onFinish = async (values) => {
    const {username: ownerName,phNum: phoneNumber,password,access} = values;
    const accessString = access.join(',');
    setLoading(true)
    const profileImage = `https://ui-avatars.com/api/background/?background=000&color=fff&size=128&rounded=true&name=${ownerName}`
    const params ={ownerName,phoneNumber,password,accountType: 'sub_account',profileImage,accessType: accessString}
    const data = await axios.post(`/owner/createSubOwner`,params)
    
    let msgObj = { code: data.code, msg: data.message }
    if(data.code == 200){
      msgObj.msg = "Successfully created sub owner account"
      form.resetFields();
    } 
    setErrorMsg(msgObj)
    setLoading(false)
    setOpenAlert(true)
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const handleCloseAlert =()=>{
    setOpenAlert(false)
  }
  const validatePassword = (_, value) => {
    if (value && !/(?=.*[A-Z])(?=.*\d).{8,}/.test(value)) {
      return Promise.reject(
        'Password must contain at least one capital letter, one number, and be at least 8 characters long'
      );
    }
    return Promise.resolve();
  };
  return (
    <div>
      <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
      <div css={css
      `padding: 0.2rem 3rem 1rem 3rem;
      border-radius: 1rem;
      margin-top: 1rem;
      margin: 1rem 10rem 0 10rem;
      box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
      -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
      `}>
        <Form
          form={form}
          name="basic"
          style={{
            marginTop: "2rem",
            fontFamily: "inherit",
          }}
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
            <Form.Item
            css={css`
      
            `}
            label="Username"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            name="username"
            hasFeedback
            rules={[
              {
                required: true,
                message: `Please input username!`,
              },
            ]}
            style={{ padding: "0 0.4rem", color: "white" }}
          >
            <Input size="large"  onChange={handleUsernameChange}/>
          </Form.Item>
          <Form.Item
            css={css`
            `}
            label="Phone Number"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            name="phNum"
            hasFeedback
      
            style={{ padding: "0 0.4rem", color: "white" }}
            rules={[
              {
                required: true,
                message: `Please input phone number!`,
              },
            ]}
          >
            <Input 
             onKeyDown={(e)=> ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()} 
             type='number'
            size="large" color='rgb(248, 250, 252)'/>
          </Form.Item>
          <Form.Item
            css={css`
            `}
            label="Password"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            name="password"
            hasFeedback
            rules={[
              {
                required: true,
                message: `Please input password!`,
              },
              {
                validator: validatePassword,
              }
            ]}
            style={{ padding: "0 0.4rem", color: "white" }}
          >
            <Input.Password size="large" color='rgb(248, 250, 252)'/>
          </Form.Item>
          <Form.Item
            css={css`
            `}
            label="Access"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            name="access"
            hasFeedback
            rules={[
              {
                required: true,
                message: `Please select access!`,
              }
            ]}
            style={{ padding: "0 0.4rem", color: "white" }}
          >
            <Select
              mode="multiple"
              size="large"
              placeholder="Please select Access"
              // onChange={handleCreateCardOptionChange}
              options={accessTypes.map(v=> {
                return {value: v.access_types,label: v.display_name}
              })}
            />
          </Form.Item>
         
          <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "center",
                    padding: "0.6rem 0 0 0",
                    marginTop: "1rem",
                  }}
                >
            
                  <ButtonBase
                    type="submit"
                    component="button"
                    style={{
                      color: "black",
                      display: "flex",
                      backgroundColor: "#408E91",
                      padding: "0.6rem 1.8rem",
                      borderRadius: "2rem",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                     {loading ? <Loader btn creatUser/>: <h4 style={{ textAlign: "center", margin: 0 }}>Save</h4>}
                  </ButtonBase>
      
                </div>
        </Form>
      </div>
    </div>
  )
}
